
const showVideoModal=(e)=>{
  e.preventDefault();
 
  const videoModal=document.createElement("div");
  videoModal.classList.add("video_modal");
  const section_video_and_close=document.createElement("section");
  section_video_and_close.classList.add("modal-vi");
  section_video_and_close.innerHTML=`<div class="video_modal_container"><iframe width="560" height="315" src="https://www.youtube.com/embed/zcDrRLZcBHc?autoplay=1&controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`
  const videoModalClose=document.createElement("img");
  videoModalClose.classList.add("fas", "fa-times", "video_modal_close");
  videoModalClose.setAttribute("src","https://cdn.shopify.com/s/files/1/0628/1796/0145/files/x-white.svg?v=1731061415");
  videoModal.appendChild(section_video_and_close);
  section_video_and_close.appendChild(videoModalClose)
  
  document.querySelector("div:has(.movie_from_mother)")?.appendChild(videoModal);
  
  videoModalClose.addEventListener("click", ()=>videoModal.remove())
  
  
}
const modal_btn=document.querySelector("div:has(.movie_from_mother) .box_a");

  modal_btn.addEventListener("click", showVideoModal);
  


